module.exports = __webpack_public_path__ + "static/img/state1.dc0913e0.png";